
import { mapGetters,mapActions } from 'vuex'
export default {
  name: 'BlocksGetGuide',
  props: {
    heading: { type: String, default: 'Download your free guide' },
    copy: { type: String, default: 'Download your free guide to teaching English abroad.' },
    btn: { type: String, default: 'Get the guide' },
    url: { type: String, default: '#' },
    img: { type: String, default: '' },
    modal: { type: String, default: '' },
    country: { type: String, default: '' },
  },
  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
  },
  methods:{
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
    }),
    updateModal(id){
      const newId = this.$nuxt.$options.filters.convertModal(id)
      this.updateActiveModal(newId)
      console.log('Active Modal: ',this.activeModal)
    }
  },
}
